import {React, useEffect, useState, useContext} from 'react'
import { CartContext } from '../context/ShopingCartContext'
import { Dropdown } from 'bootstrap';
import Swal from 'sweetalert2';
import axios from 'axios'
import CategoryCount from './CategoryCount';


const CountsView = () => {
  const [pedidos, setPedidos] = useState([]);
  const [salida, setSalida] = useState([])
  const { cart, setCart } = useContext(CartContext);
  const [cartItems, setCartItems] = useState(cart);
  const [name, setName] = useState('');
  const [price, setPrice] = useState('');
  const [ultimaActualizacion, setUltimaActualizacion] = useState(new Date());
  const [cargando, setCargando] = useState(false);

  const baseUrl = `${import.meta.env.VITE_IP}/`;
  const INTERVALO_REFRESH = 20000; // 20 segundos

  // Función para cargar todos los datos
  const cargarDatos = async () => {
    setCargando(true);
    try {
      const [pedidosRes, gastosRes] = await Promise.all([
        axios.get(baseUrl),
        axios.get(baseUrl + 'getGastos')
      ]);
      setPedidos(pedidosRes.data.checkout);
      setSalida(gastosRes.data);
      setUltimaActualizacion(new Date());
    } catch (error) {
      console.error('Error al cargar datos:', error);
    } finally {
      setCargando(false);
    }
  };

  // Cargar datos al montar el componente y configurar polling
  useEffect(() => {
    cargarDatos(); // Carga inicial

    const intervalo = setInterval(() => {
      cargarDatos();
    }, INTERVALO_REFRESH);

    // Limpiar intervalo al desmontar
    return () => clearInterval(intervalo);
  }, []); // Array vacío = solo al montar

  const deleteExitById = async(id) =>{
    const response = await axios.post(`${baseUrl}deleteExit`, {
      id:id
    })
    console.log(response.data)
  }
  // First, let's add a function to calculate transfer totals
const getTransferenciasTotal = () => {
  let total = 0;
  for (let i = 0; i < pedidos.length; i++) {
    const pedido = pedidos[i];
    if (pedido.cobrado && tieneTransferencia(pedido.cart)) {
      total += pedido.total;
    }
  }
  return total;
};

// Function to check if an order has a transfer payment
function tieneTransferencia(objetoPedido) {
  for (let i = 0; i < objetoPedido.length; i++) {
    const pedido = objetoPedido[i];
    if (pedido.hasOwnProperty('transferencia')) {
      return true;
    }
  }
  return false;
}

// Function to get total cash (excluding transfers)
const getTotalEfectivo = () => {
  let totalSinDomicilios = 0;
  let totalConDomicilios = 0;
  
  for (let i = 0; i < pedidos.length; i++) {
    const pedido = pedidos[i];
    if (pedido.cobrado && !tieneTransferencia(pedido.cart)) {
      if (tieneDomicilio(pedido.cart)) {
        totalConDomicilios += pedido.total;
      } else {
        totalSinDomicilios += pedido.total;
      }
    }
  }
  
  return {
    sinDomicilios: totalSinDomicilios,
    conDomicilios: totalConDomicilios,
    total: totalSinDomicilios + totalConDomicilios
  };
};

  const imprimirResumenDiario = () => {
    // Calculate totals
    const domiciliosTotal = getDomiTotal().total;
    
    // Calculate non-delivery orders total
    let pedidosRegularesTotal = 0;
    for (let i = 0; i < pedidos.length; i++) {
      const pedido = pedidos[i];
      if (!tieneDomicilio(pedido.cart)) {
        pedidosRegularesTotal += pedido.total;
      }
    }
    
    // Calculate grand total
    const granTotal = domiciliosTotal + pedidosRegularesTotal;
  
    // Create HTML for the summary - unchanged
    const resumenHTML = `
    <div>
      <style>
        * {
          font-family: Verdana, Arial, Helvetica, sans-serif;
          font-size: 12px;
        }
        .resumen {
          border: 1px solid #ccc;
          position: absolute;
          top: 0;
          left: 0;
          margin: 0;
          padding: 10px;
          max-width: 50mm;
        }
        .resumen header {
          text-align: center;
          margin-bottom: 10px;
        }
        .resumen .total {
          display: flex;
          justify-content: space-between;
          font-weight: bold;
          margin-top: 5px;
          margin-bottom: 10px;
        }
        .fecha {
          text-align: center;
          margin-top: 10px;
          margin-bottom: 10px;
        }
      </style>
      <div class="resumen">
        <header>
          <h3>Resumen del Día</h3>
        </header>
        <p class="fecha">
          <b>Fecha:</b> ${new Date().toLocaleDateString()}
        </p>
        <main>
          <p class="total">
            Domicilios: <span class="precio">${domiciliosTotal.toLocaleString()}</span>
          </p>
          <p class="total">
            Locales: <span class="precio">${pedidosRegularesTotal.toLocaleString()}</span>
          </p>
          <p class="total">
            Total del Día: <span class="precio">${granTotal.toLocaleString()}</span>
          </p>
        </main>
      </div>
    </div>
    `;
  
    // Open and print the summary
    const ventana = window.open('', '', 'height=500,width=500');
    ventana.document.write(resumenHTML);
    ventana.print();
    ventana.close();
  };
  
  const deleteById = async(id) =>{
    const response = await axios.post(`${baseUrl}delete`, {
      id: id,
    });
    console.log(response.data)
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const priceWithoutDots = parseFloat(price.replace('.', ''));
    axios.post(`${import.meta.env.VITE_IP}/addGasto`, { name, price: priceWithoutDots })
      .then((response) => {
        console.log(response.data);
        setName('');
        setPrice('');
      })
      .catch((error) => {
        console.error(error);
      });
  };

  
  const getDomiTotal = () =>{
    let liquidar = 0;
    let cobrados = 0;
    let total = 0;
    for (let i = 0; i < pedidos.length; i++) {
      const pedido = pedidos[i];
      if (tieneDomicilio(pedido.cart)) {
        pedido.cobrado ? cobrados += pedido.total : liquidar += pedido.total;
        total += pedido.total
      }
    }
    return {total, cobrados, liquidar};
  }
  
  const getSalidaTotal = () => {
    let total = 0;
    salida.map((salida) => total += salida.price)
    return total
  }



const handleCobrarConRecibo = async(pedido) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const now = new Date();
  const formattedDate = now.toLocaleDateString('en-US');
  const formattedTime = now.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
  const formattedDateTime = `${formattedDate} ${formattedTime}`;
if(!isMobile){
  const reciboHTML = `
  <div>
  <style>
    * {
      font-family: Verdana, Arial, Helvetica, sans-serif;
      font-size: 9px;
    }
    img{
      width: 70%;
    }
    .recibo {
      border: 1px solid #ccc;
      position: absolute;
      top: 0;
      left: 0;
      margin: 0;
      padding: 10px;
      max-width: 50mm;
    }
    .recibo header {
      text-align: center;
      margin-bottom: 10px;
    }
    .recibo ul.productos {
      list-style: none;
      margin: 0;
      padding: 0;
    }
    .recibo ul.productos li {
      display: flex;
      justify-content: space-between;
      margin-bottom: 3px;
    }
    .recibo .total {
      display: flex;
      justify-content: space-between;
      font-weight: bold;
      margin-top: 5px;
      margin-bottom: 10px;
    }
    .recibo .domicilio {
      margin-top: 10px;
      border-top: 1px solid #ccc;
      padding-top: 5px;
    }
    .recibo .domicilio p {
      margin-bottom: 5px;
    }
    .footerText{
      display:flex;
      text-align: center;
    }
  </style>
  <div class="recibo">
    <header>
      <img src="logoRecibo2.png" alt="" srcset="">
      <h3>Universo Moons</h3>
    </header>
    <main>
    <ul class="productos">
      ${pedido.cart
        .map((item) => {
          let productItem = '';
          if (!item.para && !item.domicilio && !item.aclaracion && !item.transferencia) {
            item.name == "Gaseosa" ? productItem = `<li>Gaseosas` : 
            item.name == "Adicion" ? productItem = `<li>Adiciones x ${item.price}` 
            : productItem = `<li>${item.name} ${item.quantity} x ${item.price}`;
            productItem += `</li>`;
          }
          return productItem;
        })
        .join('')}
    </ul>  
      <br>
      <br>
      <p class="total">
        Total: <span class="precio">${pedido.total.toLocaleString()}</span>
      </p>
    </main>
    <footer>
      <br>
      <p>
        <b>Fecha:</b> ${formattedDateTime}
        <br>
        <b>Domicilios:</b>  3007760669
        <br>
        <b>NIT: </b> 901806312-1
      </p>
      <p class="footerText">No somos autorretenedores de iva</p>
    </footer>
    
      
  </div>
</div>   
  `;

    const ventana = window.open('', '', 'height=500,width=500');
    ventana.document.write(reciboHTML);
    ventana.print();
    ventana.close();
    // Obtener todas las imágenes en el documento
    const images = ventana.document.getElementsByTagName('img');
    const imageCount = images.length;
    let loadedCount = 0;

    // Función para verificar si todas las imágenes se han cargado
    const checkAllImagesLoaded = () => {
      loadedCount++;
      if (loadedCount === imageCount) {
        ventana.print();
        ventana.close();
      }
    };

    // Agregar un controlador de eventos 'load' a cada imagen
    for (let i = 0; i < imageCount; i++) {
      images[i].addEventListener('load', checkAllImagesLoaded);
    }
  }

  window.location.reload();
};

const handleCobrarTodo = () => {
        // Procesar el cobro de todos los pedidos
        const promesas = pedidos.map(pedido => 
          axios.post(baseUrl + 'cobrar', pedido)
        );
        
        Promise.all(promesas)
          .then(responses => {
            console.log('Todos los pedidos cobrados con éxito', responses);
            Swal.fire({
              title: 'Listo',
              text: 'Exito al procesar los cobros',
              icon: 'success',
              confirmButtonText: 'OK',
            });
            // Aquí puedes agregar código adicional para limpiar o actualizar la interfaz
          })
          .catch(error => {
            console.error('Error al cobrar pedidos', error);
            Swal.fire({
              title: 'Error',
              text: 'Hubo un problema al procesar los cobros',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          });
    }

const handleCobrar = (pedido) => {
  Swal.fire({
    title: 'Ingrese la cantidad recibida',
    input: 'text',
    inputLabel: 'Cantidad',
    showCancelButton: true,
    confirmButtonText: 'Cobrar',
    preConfirm: (cantidad) => {
      if (!cantidad || isNaN(cantidad)) {
        Swal.showValidationMessage('Ingrese una cantidad válida');
      } else {
        return cantidad;
      }
    },
    inputAttributes: {
      autocapitalize: 'off',
      autocorrect: 'off',
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const cantidad = parseFloat(result.value);
      const total = parseFloat(pedido.total);
      const nuevoTotal = total - cantidad;
      Swal.fire({
        title: 'El cambio es:',
        text: nuevoTotal.toLocaleString(),
        icon: 'success',
        confirmButtonText: 'OK',
      }).then(() => {
        axios
          .post(baseUrl + 'cobrar', pedido)
          .then((response) => console.log(response))
          .catch((error) => console.log(error));
      });
    }
  });
};

// Nueva función para manejar cobros por transferencia
const handleTransferencia = (pedido) => {
  // Crear una copia profunda del pedido para no modificar el original
  const pedidoConTransferencia = JSON.parse(JSON.stringify(pedido));
  
  // Agregar la propiedad transferencia: true al pedido
  pedidoConTransferencia.cart.push({ transferencia: true });
  
  Swal.fire({
    title: '¿Confirmar pago por transferencia?',
    text: `Total: ${pedido.total.toLocaleString()}`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Confirmar',
    cancelButtonText: 'Cancelar',
  }).then((result) => {
    if (result.isConfirmed) {
      axios
        .post(baseUrl + 'cobrar', pedidoConTransferencia)
        .then((response) => {
          console.log(response);
          Swal.fire({
            title: 'Transferencia procesada',
            text: 'El pago por transferencia ha sido registrado',
            icon: 'success',
            confirmButtonText: 'OK',
          });
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: 'Error',
            text: 'Hubo un problema al procesar la transferencia',
            icon: 'error',
            confirmButtonText: 'OK',
          });
        });
    }
  });
};
  console.log(pedidos);

  function tieneDomicilio(objetoPedido) {
    for (let i = 0; i < objetoPedido.length; i++) {
      const pedido = objetoPedido[i];
      if (pedido.hasOwnProperty('domicilio')) {
        return pedido.domicilio.domicilio;
      }
    }
    return false;
  }

  const imprimirRecibo = async(ticketprinter) => {
    console.log("PEDIDO", ticketprinter.cart)
    const now = new Date();
    const formattedTime = now.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });

  const reciboHTML = `
  <div>
  <style>
    * {
      font-family: Verdana, Arial, Helvetica, sans-serif;
      font-size: 12px;
    }
    .recibo {
      border: 1px solid #ccc;
      position: absolute;
      top: 0;
      left: 0;
      margin: 0;
      padding: 10px;
      max-width: 50mm;
    }
    .recibo header {
      text-align: center;
      margin-bottom: 10px;
    }
    .recibo ul.productos {
      list-style: none;
      margin: 0;
      padding: 0;
    }
    .recibo ul.productos li {
      display: flex;
      justify-content: space-between;
      margin-bottom: 3px;
    }
    .recibo .total {
      display: flex;
      justify-content: space-between;
      font-weight: bold;
      margin-top: 5px;
      margin-bottom: 10px;
    }
    .recibo .domicilio {
      margin-top: 10px;
      border-top: 1px solid #ccc;
      padding-top: 5px;
    }
    .recibo .domicilio p {
      margin-bottom: 5px;
    }
  </style>
  <div class="recibo">
    <header>
      <h3>Pedido</h3>
    </header>
    <main>
    <ul class="productos">
      ${ticketprinter.cart
        .map((item) => {
          let productItem = '';
          if (!item.para && !item.domicilio && !item.aclaracion && !item.transferencia) {
            item.name == "Gaseosa" ? productItem = `<li>Gaseosas` : item.name == "Adicion" ? productItem = `<li>Adiciones` : productItem = `<li>${item.quantity} ${item.name}`;
            if (item.especificacion) {
              productItem += `<li><b>${item.especificacion}</b></li>`;
            }
            productItem += `</li>`;
          }
          return productItem;
        })
        .join('')}
    </ul>  
      <br />
      <br />
      <p class="total">
        Total: <span class="precio">${ticketprinter.total.toLocaleString()}</span>
      </p>
    </main>
    <footer>
      <p>
        <b>Hora:</b> ${formattedTime}
      </p>
      ${ticketprinter.cart
        .filter((item) => item.para)
        .map(
          (item) =>
            `<p><b>Para:</b> ${item.para.value}</p>`
        )
        .join('')}
    </footer>
    ${ticketprinter.cart
      .filter((item) => item.domicilio)
      .map(
        (item) =>
          `<div class="domicilio">
            <p><b>Domicilio:</b></p>
            <p>${item.domicilio.message}</p> 
          </div>`
      )
      .join('')}
      ${ticketprinter.cart
        .filter((item) => item.aclaracion)
        .map(
          (item) =>
            `<div class="domicilio">
              <p><b>Especificaciónes:</b></p>
              <p>${item.aclaracion.message}</p> 
            </div>`
        )
        .join('')}
  </div>
</div>  
  `;

  const ventana = window.open('', '', 'height=500,width=500');
  ventana.document.write(reciboHTML);
  ventana.print();
  ventana.close();
}
  return (
    <div className="counts-view-container">
      <div className="action-buttons">
        <button type="button" className="btn-action btn-success" onClick={() => handleCobrarTodo()}>Cobrar todo</button>
        <button type="button" className="btn-action btn-primary" onClick={imprimirResumenDiario}>Imprimir Resumen del Día</button>
        <button
          type="button"
          className="btn-action btn-secondary"
          onClick={cargarDatos}
          disabled={cargando}
        >
          {cargando ? 'Actualizando...' : 'Actualizar Pedidos'}
        </button>
        <small style={{display: 'block', marginTop: '5px', color: '#666'}}>
          Última actualización: {ultimaActualizacion.toLocaleTimeString()}
        </small>
      </div>
      
      <div className="section-container">
        <h3 className="section-title">Pedidos pendientes</h3>
        <div className="table-responsive">
          <table className="custom-table"> 
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Nombre</th>
                <th scope="col">Pedido</th>
                <th scope="col">Total</th>
                <th scope="col">Facturar</th>
                <th scope="col">Opciones</th>
              </tr>
            </thead>
            <tbody>
              {pedidos.map((pedido) => (
              tieneDomicilio(pedido.cart) != true & pedido.cobrado == false && (<>         
              <tr key={pedido._id}>
                <th scope="row">{pedido.id}</th>
                <th>{pedido.cart.map((item) => !item.para ? (<></>):(<>{item.para.value}</>))}</th>
                <td>{pedido.cart.map((item) => <>{item.quantity} {item.name}<br /></>)}</td>
                <td className="price-cell">{pedido.total.toLocaleString()}</td>
                <td className="button-group">
                  <button type="button" className="btn-table btn-success" onClick={() => handleCobrar(pedido)}>Cobrar</button>
                  <button type="button" className="btn-table btn-success" onClick={() => handleCobrarConRecibo(pedido)}>Recibo</button>
                  <button type="button" className="btn-table btn-success" onClick={() => handleTransferencia(pedido)}>Transferencia</button>
                </td>
                <td className="button-group">
                  <button type="button" className="btn-table btn-info" onClick={() => setCart([pedido])}>Modificar</button>
                  <button type="button" className="btn-table btn-danger" onClick={() => deleteById(pedido.id)}>Eliminar</button>
                  <button type="button" className="btn-table btn-dark" onClick={() => imprimirRecibo(pedido)}>Imprimir</button>
                </td>
              </tr></>)
              ))}
            </tbody>
          </table>
        </div>
      </div>
      
      <div className="section-container">
        <h3 className="section-title">Domicilios</h3>
        <div className="table-responsive">
          <table className="custom-table"> 
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Nombre</th>
                <th scope="col">Pedido</th>
                <th scope="col">Dirección</th>
                <th scope="col">Total</th>
                <th scope="col">Facturar</th>
                <th scope="col">Opciones</th>
              </tr>
            </thead>
            <tbody>
            {pedidos.map((pedido) => (
              tieneDomicilio(pedido.cart) == true && (<>           
              <tr key={pedido._id} className={pedido.cobrado == true ? 'row-success' : ''}>
                <th scope="row">{pedido.id}</th>
                <th>{pedido.cart.map((item) => !item.para ? (<></>):(<>{item.para.value}</>))}</th>
                <td>{pedido.cart.map((item) => <>{item.quantity} {item.name}<br /></>)}</td>
                <td>{pedido.cart.map((item) => item.domicilio && item.domicilio.message)}</td>
                <td className="price-cell">{pedido.total.toLocaleString()}</td>
                <td className="button-group">
                  <button type="button" className="btn-table btn-success" onClick={() => handleCobrar(pedido)}>Cobrar</button>
                  <button type="button" className="btn-table btn-success" onClick={() => handleTransferencia(pedido)}>Transferencia</button>
                  <button type="button" className="btn-table btn-success" onClick={() => handleCobrarConRecibo(pedido)}>Recibo</button>
                </td>
                <td className="button-group">
                  <button type="button" className="btn-table btn-info" onClick={() => setCart([pedido])}>Modificar</button>
                  <button type="button" className="btn-table btn-danger" onClick={() => deleteById(pedido.id)}>Eliminar</button>
                  <button type="button" className="btn-table btn-dark" onClick={() => imprimirRecibo(pedido)}>Imprimir</button>
                </td>
              </tr></>) 
              ))}
            </tbody>
          </table>
          <div className="summary-box">
            <p><b>Total dinero dejado por domicilios: </b> <span className="price-highlight">{getDomiTotal().total.toLocaleString()}</span></p>
            <p><b>Total domicilios ya pagados: </b> <span className="price-highlight">{getDomiTotal().cobrados.toLocaleString()}</span></p>
            <p><b>Total a liquidar: </b> <span className="price-highlight">{getDomiTotal().liquidar.toLocaleString()}</span></p>
          </div>
        </div>
      </div>
      
      <CategoryCount data={"Dia"}/>
      
      <div className="section-container">
        <h3 className="section-title">Pedidos cobrados</h3>
        <div className="table-responsive">
          <table className="custom-table"> 
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Nombre</th>
                <th scope="col">Pedido</th>
                <th scope="col">Total</th>
                <th scope="col">Facturar</th>
                <th scope="col">Opciones</th>
              </tr>
            </thead>
            <tbody>
              {pedidos.map((pedido) => (
              pedido.cobrado == true & tieneDomicilio(pedido.cart) != true && (<>            
              <tr key={pedido._id}>
                <th scope="row">{pedido.id}</th>
                <th>{pedido.cart.map((item) => !item.para ? (<></>):(<>{item.para.value}</>))}</th>
                <td>{pedido.cart.map((item) => <>{item.quantity} {item.name}<br /></>)}</td>
                <td className="price-cell">{pedido.total.toLocaleString()}</td>
                <td className="button-group">
                  <button type="button" className="btn-table btn-success" onClick={() => handleCobrar(pedido)}>Cobrar</button>
                  <button type="button" className="btn-table btn-success" onClick={() => handleCobrarConRecibo(pedido)}>Recibo</button>
                  <button type="button" className="btn-table btn-success" onClick={() => handleTransferencia(pedido)}>Transferencia</button>
                </td>
                <td className="button-group">
                  <button type="button" className="btn-table btn-info" onClick={() => setCart([pedido])}>Modificar</button>
                  <button type="button" className="btn-table btn-danger" onClick={() => deleteById(pedido.id)}>Eliminar</button>
                  <button type="button" className="btn-table btn-dark" onClick={() => imprimirRecibo(pedido)}>Imprimir</button>
                </td>
              </tr></>)
              ))}
            </tbody>
          </table>
        </div>
        
        <div className="summary-box">
          <h4 className="section-title">Resumen de Ingresos</h4>
          <p><b>Total por transferencias: </b> <span className="price-highlight">{getTransferenciasTotal().toLocaleString()}</span></p>
          <p><b>Total en caja (sin domicilios): </b> <span className="price-highlight">{getTotalEfectivo().sinDomicilios.toLocaleString()}</span></p>
          <p><b>Total en caja (con domicilios): </b> <span className="price-highlight">{getTotalEfectivo().conDomicilios.toLocaleString()}</span></p>
          <p><b>Total en caja: </b> <span className="price-highlight">{getTotalEfectivo().total.toLocaleString()}</span></p>
        </div>
      </div>

      <div className="section-container">
        <h4 className="section-title">Agregar gastos</h4>
        <form onSubmit={handleSubmit} className="expense-form">
          <div className="form-group">
            <label htmlFor="name">Nombre:</label>
            <input
              type="text"
              className="form-input"
              id="name"
              placeholder="Ingresa el nombre"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="price">Precio:</label>
            <input
              type="number"
              className="form-input"
              id="price"
              placeholder="Ingresa el precio"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn-action btn-primary">Agregar gasto</button>
        </form>
        
        <div className="table-responsive">
          <h4 className="section-title">Gastos</h4>
          <table className="custom-table"> 
            <thead>
              <tr>
                <th scope="col">Nombre</th>
                <th scope="col">Dinero</th>
                <th scope="col">Opciones</th>
              </tr>
            </thead>
            <tbody>
            {salida.map((salida) => (
            <>           
            <tr key={salida._id}>
                <th>{salida.name}</th>
                <td className="price-cell">{salida.price.toLocaleString()}</td>
                <td>
                  <button type="button" className="btn-table btn-danger" onClick={() => deleteExitById(salida.id)}>Eliminar</button>
                </td>
              </tr>
              </>) 
              )}
            </tbody>
          </table>
          <div className="summary-box">
            <p><b>Total dinero salido: </b> <span className="price-highlight">{getSalidaTotal().toLocaleString()}</span></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountsView;
